import React from "react";
import ClickToFlyPricingConfigContent from "../components/click-to-fly/click-to-fly-pricing-config-content";

const ClickToFlyPricingConfig = () => {
  return <ClickToFlyPricingConfigContent />;
};

export default ClickToFlyPricingConfig;

